import { useState, useEffect } from "react";
import { Button, ConfigProvider, Input, message } from "antd";
import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { SearchOutlined } from "@ant-design/icons";

const SearchBar = ({ hideInput }) => {
    const [searchValue, setSearchValue] = useState("");
    const [placeholderText, setPlaceholderText] = useState("");
    const { t } = useTranslation();
    const navigate = useNavigate();

    const searchPhrases = [
        "ремувер LaOne",
        "патчи LaOne",
        "ресницы LaOne",
        "обезжириватель LaOne",
        "скотч LaOne"
    ];

    useEffect(() => {
        let index = 0;
        const interval = setInterval(() => {
            setPlaceholderText(searchPhrases[index]);
            index = (index + 1) % searchPhrases.length;
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    const handleSearch = () => {
        if (!searchValue.trim()) {
            message.warning(t("Search.empty"));
            return;
        }

        navigate(`/search?text=${encodeURIComponent(searchValue.trim())}`);
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleSearch();
        }
    };

    return (
        <>
            {hideInput ? (
                <Button
                    color="default"
                    type="link"
                    size="middle"
                    icon={<Search color="black" size={32} strokeWidth={1} />}
                    onClick={handleSearch}
                />
            ) : (
                <ConfigProvider
                    theme={{
                        components: {
                            Input: {
                                activeBorderColor: "black",
                            },
                        },
                    }}
                >
                    <Input
                        variant="filled"
                        placeholder={placeholderText || t("search")}
                        size="large"
                        addonAfter={
                            <Button
                                color="#000000"
                                type="link"
                                variant="filled"
                                icon={<SearchOutlined />}
                                size={32}
                                onClick={handleSearch}
                            >
                                {t("find")}
                            </Button>
                        }
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        onPressEnter={handleKeyPress}
                    />
                </ConfigProvider>
            )}
        </>
    );
};

SearchBar.propTypes = {
    hideInput: PropTypes.bool,
};

export default SearchBar;